import React from "react";
import Icon from "@mdi/react";
import { mdiCheckCircle } from "@mdi/js";
import "./InstructorAvatarPresets.css";

const InstructorAvatarPresets = ({ presets, selectedId, applyingId, onSelect }) => {
    if (!presets?.length) return null;
    return (
        <div className="instructor-avatar-presets">
            <p className="form-hint">Or pick a character avatar</p>
            <div className="preset-row">
                {presets.map(preset => {
                    const isSelected = preset.id === selectedId;
                    const isApplying = preset.id === applyingId;
                    return (
                        <button
                            key={preset.id}
                            type="button"
                            className={`preset-thumb${isSelected ? " selected" : ""}`}
                            onClick={() => onSelect(preset)}
                            disabled={!!applyingId}
                            aria-label={preset.label}>
                            <img src={preset.src} alt={preset.label} className="preset-thumb-img" />
                            {isSelected && !isApplying && (
                                <span className="preset-check">
                                    <Icon path={mdiCheckCircle} size={0.8} color="var(--dl-color-purple-default)" />
                                </span>
                            )}
                            {isApplying && <span className="preset-applying">Applying...</span>}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default InstructorAvatarPresets;
